if (!customElements.get('custom-formatted-number')) {
    class CustomFormattedNumber extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init() {
            // Get the value from the data-value attribute
            const rawValue = this.getAttribute('data-value');

            // Ensure the value exists and is a valid number
            const numberValue = rawValue ? Number(rawValue) : null;

            if (numberValue !== null && !isNaN(numberValue)) {
                this.textContent = window.CustomNumberFormatters.formatNumber(numberValue);
            } else {
                this.textContent = ''; // Handle cases where the value is missing or invalid
            }
        }
    }

    customElements.define(
        'custom-formatted-number',
        CustomFormattedNumber,
    )
}